<img [style.width.px]="widthLogo" [src]="'assets/images/df-logo.svg'" alt="Danceflavors Logo" />
